import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreatePartyAccount,
  DELETE_Account_MUTATION,
  EDIT_PartyAccount,
  GetAccountRefrencesByID,
  GrtPreferenceByFormKey,
  MERGE_ACCOUNT,
  PartyAccountDataByID
} from "../../../../Utils/AllPagesQuriesAndMutations";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import Button from "../../Button/Button";
import { Confirm } from "../../Confirmation/Confirm";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import { AmountDetails, initialRef, TransactionTypeDetails } from "../ReferenceSection/Reference.config";
import { ReferenceModal } from "../ReferenceSection/ReferenceModal";
import { DefaultConfiguration } from "./AddGeneralAccount.config";
import "./AddGeneralAccount.scss";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";

const AddGeneralAccount = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction, setShow, ReferenceFieldName = [],
  ReferFormKey = "", }) => {

  const ReferenceData = useSelector((store) => store.TableDataReducer.tableData);
  const Form_Key ="General_Account";
  const formRef = useRef({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.General_Account?.Selected_Row || fielddataRedux?.Account_Vouchers?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [FormData, setFormdata] = useState({});
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const [openSetting, setOpenSetting] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);
  const [RefRows, setRefRows] = useState({ 1: {} });
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [openRef, setOpenRef] = useState(false);
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });


  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key: TypeOfPortal == "Merge" ? "General_Account_Merge" : "General_Account" });
  const [GetRefByID] = useLazyQuery(GetAccountRefrencesByID, {
    fetchPolicy: "network-only",
  });
  const [CreatingData, { loading: createPartyAccountLoading }] = useMutation(CreatePartyAccount);

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(PartyAccountDataByID, {
    fetchPolicy: "network-only",
  });
  const [MergingData, { loading: MergeEmtAccountLoading }] = useMutation(MERGE_ACCOUNT, {
    fetchPolicy: "network-only",

  });
  const [EditingData, { loading: editPartyAccountLoading }] = useMutation(EDIT_PartyAccount);

  const [DeletingData, { loading: deletePartyAccountLoading }] = useMutation(DELETE_Account_MUTATION);

  const [getDataByKey, { loading: userPreferenceLoading }] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const PartyAccountLoadingState =
    deletePartyAccountLoading ||
    editPartyAccountLoading ||
    createPartyAccountLoading ||
    GetDataByIDLoader ||
    getFormFieldsLoading ||
    userPreferenceLoading;
  const OpenReference = () => {
    setOpenRef(true);
  };
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const getDefaultValues = async () => {
    try {
      const { data } = await getDataByKey({
        variables: {
          Form_Key,
        },
      });

      let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };

      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: { Account_Group: obj.accountgroups },
        },
      });
      obj.Account_Group = obj?.accountgroups?.Search_Value;
      obj.accountgroups = obj?.accountgroups?.Search_Value;
      setFormdata((prev) => ({
        ...prev,
        ...obj,
      }));
      updateValueForm(formRef, {
        ...obj,
        Credit_Or_Debit: "Db",
        Opening_Balance: 0,
        Account_Type:"General Account",
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        if (TypeOfPortal !== "Add") {
          GetDataByID({
            variables: {
              id: fielddata?._id,
            },
          }).then(({ data }) => {
            let GeneralAccountData = { ...data?.Account };
            GeneralAccountData.Balance_Method = data?.Account?.Balance_Method === "Bill By Bill" ? true : false;
            dispatch({
              type: "SearchMasterData",
              payload: {
                Account_Group: { _id: GeneralAccountData?.Account_Groups?._id },
              },
            });
            if (GeneralAccountData && GeneralAccountData.Account_Groups) {
              GeneralAccountData.Account_Group = GeneralAccountData.Account_Groups.Account_Group;
            }
            if (GeneralAccountData?.customFieldData && typeof GeneralAccountData.customFieldData === "object") {
              Object.entries(GeneralAccountData.customFieldData).forEach(([key, value]) => {
                GeneralAccountData[key] = value ?? ""; // Assign value or empty string if undefined/null
              });
            }
            setAllFieldsData(GeneralAccountData);
            updateValueForm(formRef, GeneralAccountData);
          });
          GetRefByID({
            variables: {
              Account_Id: fielddata?._id,
            },
          }).then(({ data }) => {
            if (data?.getAccountRefrencesByID?.length) {

              let updatedTransRef = {};
              data?.getAccountRefrencesByID?.map((el) => {
                let InitialRef = [
                  ...initialRef.slice(0, -1),
                  AmountDetails,
                  TransactionTypeDetails,
                  initialRef[initialRef.length - 1],
                ];
                let singleRef = InitialRef.map((item) => {
                  if (item.name === "Particular") {
                    item = { ...item, NewRef_Id: el["NewRef_Id"] };
                  }
                  if (item.name === "RefDate") {
                    return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
                  }
                  return { ...item, value: el[item.name] };
                });
                updatedTransRef = {
                  ...updatedTransRef,
                  [Math.random() * 10]: singleRef,
                };
              });
              console.log(updatedTransRef);
              setRefRows({
                [1]: updatedTransRef,
              });
            }
          });
        } else {
          // Call the async function
          getDefaultValues();
        }
      });
    }
  }, [fielddata]);
  useEffect(() => {
    let total = FormData?.Opening_Balance;
    console.log(total, isFirstLoad, FormData?.Balance_Method, FormData?.Credit_Or_Debit);
    if (
      total &&
      (FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) &&
      FormData?.Credit_Or_Debit &&
      isFirstLoad
    ) {
      let InitialRef = [
        ...initialRef.slice(0, -1),
        AmountDetails,
        TransactionTypeDetails,
        initialRef[initialRef.length - 1],
      ];

      let singleRef = InitialRef.map((item) => {
        console.log(item, "itemitem");
        if (item.name === "Particular") {
          return { ...item, value: FormData?.Invoice_No || "" };
        }
        if (item.name === "Type") {
          return { ...item, value: `New Reference` };
        }
        if (item.name === "Amount") {
          return { ...item, value: total };
        }
        if (item.name === "TransactionType") {
          console.log(FormData?.Credit_Or_Debit, FormData);
          return {
            ...item,
            value: FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : "",
          };
        }
          if (item.name === "RefDate") {
                  return { ...item, value: GetTodaysDateINdmy() };
                }
        return item;
      });

      let updatedTransRef = {
        [Math.random() * 10]: singleRef,
      };
      console.log(updatedTransRef, "updatedTransRefupdatedTransRef");
      setRefRows({
        [1]: updatedTransRef,
      });
    }
  }, [FormData?.Opening_Balance, FormData?.Credit_Or_Debit, FormData?.Balance_Method]);

  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);
  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    setSelectedRows(fielddataRedux?.General_Account?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let newFormData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, newFormData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
    MergingData
  };

  useEffect(() => {
    if (inputFields && inputFields?.length > 0) {
      const fields = extractCustomFields(inputFields);
      setStoreCustomFields(fields);
    }
  }, [inputFields]);

  const submit = async (closeAction) => {
    let formData = {}

    if (operationType === "Merge") {
      formData.existingId = fielddata?._id;
      formData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
      variables.existingId = fielddata?._id;
      variables.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
    }
    else {
      formData = processFormDataWithCustomFields(newFormData, storeCustomFields);
      formData.Account_Type = formData.Account_Type || "General Account";
      formData.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
      delete formData.accountgroups;
      if (operationType !== "Delete") {
        if (formData.Aadhar_Number && typeof formData.Aadhar_Number !== "string") {
          formData.Aadhar_Number = formData.Aadhar_Number.toString();

        }
        if (formData.Aadhar_Number) {
          formData.Aadhar_Number = formData.Aadhar_Number.replace(/[^0-9]/g, "");
        }
      }
      formData.Balance_Method = formData?.Balance_Method ? "Bill By Bill" : "Balance only";

    }

    let References = (ReferenceData[1] ? Object.keys(ReferenceData[1]) : []).map((key) => {
      let obj = {};
      let flag = true;
      ReferenceData[1][key].forEach((item) => {
        // if (item?.name === "Unique_Id") {
        //   return;
        // }
        if (item.name === "RefDate" && item.value) {
          obj = {
            ...obj,
            [item.name]: convertToISO(item.value),
          };
        }
        else if (item?.name === "Particular") {
          if (!item.value) {
            obj = {
              ...obj,
              [item.name]: "",
            };
          }
          obj = {
            ...obj,
            [item.name]: item.value,
          };
          if (item?.NewRef_Id) {
            obj = { ...obj, NewRef_Id: item.NewRef_Id };
          }
        } else if (item) {
          obj = { ...obj, [item.name]: item.value };
        }
      });
      console.log(obj, flag);
      // if (flag) {
      return obj;
      // }
    });

    if ((FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true)) {

      variables.ReferenceInput = References;
    }
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: () => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
        getDefaultValues()
      },
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
    ClearSpecificForm(dispatch, Form_Key);
    if (setShow) {
      setShow(false);
    }
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock" || TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={false}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => (
        TypeOfPortal !== "Merge" && <>
          {FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true ? (
            <>
              <Button action={() => OpenReference()} name="modalbutton" text="Reference" />
            </>
          ) : (
            <></>
          )}
        </>
      )}
      disabled={isDisabled}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
            Validate_handleSubmit(SaveAndCloseForAdd);
          }
          : () => {
            Validate_handleSubmit(submit);
          }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={PartyAccountLoadingState}
    />
  );

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  return (
    <div>
      <Reactportal
        FoooterContent={footerContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal + " " + "General Account"}
        AdditionalContent={() => {
          return (
            <>

            </>
          );
        }}
      >
        <div className="PartyAccountSection">
          {PartyAccountLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {inputFields && inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <div className="FormSectionParent" key={e.id}>
                  {e?.name.startsWith("Parent") ? (
                    e.sections?.map((el) => (
                      <div key={el.name}>
                        <div className="sectionHeadings">{replaceUnderscore(el.name)}</div>
                        <div className="FormSection">
                          <FormInputSectionComponent
                            fielddata={allFieldsData}
                            inputfields={el.fields}
                            Type={el.name}
                            onErrorsChange={handleErrorsChange}
                            onhandleFormikChange={HanldeChangeonForm}
                            TypeOfPortal={TypeOfPortal}
                            formkey={Form_Key}
                            formRef={formRef}
                            setFirstLoad={setFirstLoad}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="FormSection">
                        <FormInputSectionComponent
                          fielddata={allFieldsData}
                          inputfields={e.fields}
                          Type={e.name}
                          onErrorsChange={handleErrorsChange}
                          onhandleFormikChange={HanldeChangeonForm}
                          TypeOfPortal={TypeOfPortal}
                          formkey={Form_Key}
                          formRef={formRef}
                          setFirstLoad={setFirstLoad}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available.</p>
            ) : null}
          </div>
          {openSetting && (
            <FormConfiguration
              show={openSetting}
              ParentClosingFunction={setOpenSetting}
              config={DefaultConfiguration}
              HanldeChangeonForm={HanldeChangeonForm}
              formRef={formRef}
              allFieldsData={allFieldsData}
              getFormSectionAndFields={getFormSectionAndFields}
              ToGetDefaultValues={() => {
                getDefaultValues();
              }}
              formKey={Form_Key}
              forFormValues={FormData}
            />
          )}
          {openRef && (
            <ReferenceModal
              show={openRef}
              setModalToggle={() => setOpenRef(false)}
              transactionId={1}
              Amount={FormData?.Opening_Balance}
              Account_ID={""}
              query={""}
              Transaction_Type={
                FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : ""
              }
            />
          )}
        </div>
      </Reactportal>
    </div>
  );
};

export default AddGeneralAccount;
